module.exports = __webpack_public_path__ + "static/media/money-bag 1.3b7bc2d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/money-bag 1.svg
// module id = 3205
// module chunks = 0